import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const getNotifications = async (businessId) => {
  try {
    const result = await http.get(`${URL}/notification/${businessId}`);
    // console.log("result", result.data)
    return result.data;
  } catch (error) {
    return errorHandler(error);
  }
};
// In your notification service file
export const markAllNotificationsAsRead = async (businessId) => {
  try {
    const response = await http.put(
      `${URL}/notification/${businessId}/mark-all-read`
    );

    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};
export const markNotificationAsRead = async (businessId, id) => {
  try {
    if (!id || id.length !== 24 || !businessId) {
      throw new Error("Invalid ID format - must be 24 characters");
    }
    const response = await http.put(
      `${URL}/notification/${businessId}/${id}/read`
    );

    return response.data;
  } catch (error) {
    console.error("Error in markNotificationAsRead:", {
      businessId,
      id,
      error: error.response?.data || error.message,
    });
    throw error;
  }
};
